import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgStar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M12.93.604l1.67 3.532c.15.32.442.54.78.592l3.731.567c.85.129 1.19 1.22.574 1.846l-2.7 2.75a1.113 1.113 0 00-.298.958l.638 3.882c.144.885-.744 1.56-1.505 1.142l-3.337-1.833a.997.997 0 00-.965 0L8.18 15.873c-.762.418-1.65-.257-1.505-1.142l.638-3.882a1.11 1.11 0 00-.298-.959L4.314 7.14c-.615-.625-.275-1.716.575-1.845l3.732-.567c.337-.051.629-.273.78-.592l1.67-3.532a1.018 1.018 0 011.859 0"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Star')(SvgStar);
